/* variant-image-swap.js — safe with LazySizes + non-lazy images */
(function () {
  'use strict';

  function findTargetImage(fromEl) {
    const card =
      fromEl.closest('.ProductItem') ||
      fromEl.closest('[data-product-card]') ||
      null;
    if (!card) return null;
    // Prefer the primary image
    return (
      card.querySelector('img.js-qa-img') ||
      card.querySelector('img.ProductItem__Image:not(.ProductItem__Image--alternate)') ||
      card.querySelector('.ProductItem__ImageWrapper img') ||
      card.querySelector('img')
    );
  }

  function normalizeUrl(urlTemplate, width) {
    if (!urlTemplate) return null;
    let url = String(urlTemplate);
    if (url.includes('{width}')) return url.replace('{width}', width);
    if (/_1x1\./.test(url)) return url.replace(/_1x1\./, `_${width}x.`);
    return url;
  }

  function parseWidths(val) {
    if (!val) return [];
    try {
      if (/^\s*\[/.test(val)) return (JSON.parse(val) || []).map(n => parseInt(n, 10)).filter(Boolean);
      return String(val).split(',').map(s => parseInt(s.trim(), 10)).filter(Boolean);
    } catch { return []; }
  }

  function buildSrcset(urlTemplate, widthsStr) {
    const widths = parseWidths(widthsStr);
    if (!urlTemplate || !widths.length) return '';
    return widths.map(w => `${normalizeUrl(urlTemplate, w)} ${w}w`).join(', ');
  }

  function currentPixelSize(img) {
    const w = img.clientWidth || parseInt(getComputedStyle(img).width, 10) || 800;
    return `${Math.max(1, Math.round(w))}px`;
  }

  function swapCardImage(swatchEl) {
    const urlTemplate  = swatchEl.getAttribute('data-image-url');
    const widthsString = swatchEl.getAttribute('data-image-widths') || '[200,400,600,700,800,900,1000,1200]';
    if (!urlTemplate) return;

    const img = findTargetImage(swatchEl);
    if (!img) return;

    const srcset = buildSrcset(urlTemplate, widthsString);
    const immediate = normalizeUrl(urlTemplate, 600) || normalizeUrl(urlTemplate, 800) || urlTemplate;

    const isLazyLoaded = img.classList.contains('lazyloaded') || img.classList.contains('Image--lazyLoaded');
    const isLazy = img.hasAttribute('data-srcset') || img.classList.contains('lazyload') || img.classList.contains('Image--lazyLoad');

    if (isLazyLoaded) {
      if (srcset) {
        img.setAttribute('srcset', srcset);
        img.removeAttribute('data-srcset');
      }
      img.setAttribute('sizes', currentPixelSize(img));
      if (immediate) img.src = immediate;
    } else if (isLazy) {
      if (srcset) img.setAttribute('data-srcset', srcset);
      img.setAttribute('data-sizes', 'auto');
      if (window.lazySizes && window.lazySizes.loader) {
        window.lazySizes.loader.unveil(img);
      } else {
        if (srcset) img.setAttribute('srcset', srcset);
        if (immediate) img.src = immediate;
      }
    } else {
      if (srcset) img.setAttribute('srcset', srcset);
      if (immediate) img.src = immediate;
    }
  }

  function handleChange(e) {
    const input = e.target.closest('.ColorSwatch__Radio, [data-variant-swatch]');
    if (!input) return;
    if (input.type === 'radio' && !input.checked) return;
    swapCardImage(input);
  }

  document.addEventListener('change', handleChange);
  document.addEventListener('click', (e) => {
    const input = e.target.closest('.ColorSwatch__Radio, [data-variant-swatch]');
    if (!input) return;
    setTimeout(() => handleChange({ target: input }), 0);
  });

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.ColorSwatch__Radio:checked, [data-variant-swatch][aria-checked="true"]')
      .forEach(s => swapCardImage(s));
  });
})();
